import { Asset } from "../../models/assets.model";
import { CommandDeleteComment } from "./commands/cmdDeleteComment";
import { CommandFetchComment } from "./commands/cmdFetchComment";
import { CommandPatchComment } from "./commands/cmdPatchComment";
import { CommandPostComment } from "./commands/cmdPostComment";
import { CommandPostAdComment } from "./commands/cmdPostAdComment";


export class CommentService {

    /** Comment on a GuidePost from the content page (MPN-1454). */
    async postAdComment(
        organizationId: number,
        adId: number,
        comment: string,
        isClientVisible: boolean,
    ) {
        const cmd = new CommandPostAdComment();
        return await cmd.run(organizationId, adId, comment, isClientVisible);
    }

    async postComment(organizationId:number, todoId:number, comment: string, files:Asset[]) {
        const cmd = new CommandPostComment();
        const results = await cmd.run(organizationId, todoId, comment, files);
        return results;
    }

    async updateComment(todoId:number, organizationId:number, commentId: number, comment: string, assets:Asset[]) {
        const cmd = new CommandPatchComment();
        const results = await cmd.run(todoId, organizationId, commentId, comment, assets);
        return results;
    }

    async deleteComment(todoId:number, commentId: number) {
        const cmd = new CommandDeleteComment();
        const results = await cmd.run(todoId,commentId);
        return results;
    }

    async fetchComments(todoId:number) {
        const cmd = new CommandFetchComment();
        const results = await cmd.run(todoId);
        return results;
    }
    
   
}

